import { makeStyles } from '@mui/styles';
import { black, green, orange, red } from 'apollo-react/colors';
import classNames from 'classnames';
import React from 'react';

import { COMPLETED_LABEL, STATUSES } from '../../../../constants/import.constants';

const useStyles = makeStyles({
  error: {
    color: red,
  },
  completed: {
    color: green,
  },
  inProgress: {
    color: orange,
  },
  cancel: {
    color: black,
  },
});

const StatusCell = ({ row, column: { accessor } }) => {
  const classes = useStyles();
  const status = row[accessor] ?? STATUSES.PENDING;

  return (
    <div
      className={classNames(
        status === STATUSES.ERROR
          ? classes.error
          : status === STATUSES.COMPLETED
          ? classes.completed
          : status === STATUSES.IN_PROGRESS
          ? classes.inProgress
          : status === STATUSES.CANCEL
          ? classes.cancel
          : null
      )}
    >
      {status === STATUSES.COMPLETED ? COMPLETED_LABEL : status}
    </div>
  );
};

export default StatusCell;
